
'use strict';

export function _setProgressbarPosition(event, slick, currentSlide, nextSlide) {
    let _ele = $(event.currentTarget).parents('.product-gallery__wrapper'),
        _sliderProgress = _ele.find('.swiper-scrollbar-drag'),
        _imgLength = $(event.currentTarget).find('.product-gallery__col').length,
        _sliderProgressWidth = 100 / _imgLength,
        _sliderProgressLeft = _sliderProgressWidth * nextSlide,
        _getScreenDirection = $(event.currentTarget).parents('html').attr('dir');
    _sliderProgress.css('bottom', '7px');
    _sliderProgress.width(_sliderProgressWidth + '%');
    if (_getScreenDirection == 'rtl') {
        _sliderProgress.css({ marginRight: _sliderProgressLeft + '%' });
    } else {
        _sliderProgress.css({ marginLeft: _sliderProgressLeft + '%' });
    }
}

export function _setProgressbarPositionOnLoad(ImageItem) {
    let _ele = $(ImageItem),
        _imgLength = _ele.find('.product-gallery__col').length,
        _sliderProgressWidth = 100 / _imgLength;
    $('.swiper-scrollbar-drag').css('bottom', '7px');
    if (_imgLength > 1) {
        $('.swiper-scrollbar-drag').width(_sliderProgressWidth + '%');
    } else {
        $('.swiper-scrollbar-drag').addClass('hidden');
    }
}

export function productImageGalleryItemInit() {
    let product_pdp = document.querySelector('.product-gallery--pdp'),
        slickList = $(product_pdp).find('.slick-list'),
        allsilckTrack = $(slickList).find('.slick-track');
    [].forEach.call(allsilckTrack, function(ImageItem) {
        _setProgressbarPositionOnLoad(ImageItem);
    });
    $('.product-gallery--pdp').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        _setProgressbarPosition(event, slick, currentSlide, nextSlide);
    });

}
